export const ACTIONS_DROPDOWN = {
  en: {
    viewProfile: "View Profile",
    removeUser: "Remove User",
  },
  ar: {
    viewProfile: "عرض الملف الشخصي",
    removeUser: "حذف المستخدم",
  },
};

export const FOOTER = {
  en: {
    termsAndConditions: "Terms and Conditions",
    privacyPolicy: "Privacy Policy",
    contactUs: "Contact Us",
    aboutSalah: "About Salah",
  },
  ar: {
    termsAndConditions: "الشروط والأحكام",
    privacyPolicy: "سياسة الخصوصية",
    contactUs: "اتصل بنا",
    aboutSalah: "عن صلاح الراشد",
  },
};

export const HEADER = {
  en: {
    helpAndSupport: "Help & Support",
    accountSettings: "Account Settings",
    logout: "Logout",
    dashboard: "Dashboard",
    language: "Language",
  },
  ar: {
    helpAndSupport: "المساعدة والدعم",
    accountSettings: "إعدادات الحساب",
    logout: "تسجيل الخروج",
    dashboard: "الرئيسية",
    language: "اللغة",
  },
};

export const THREE_DOTS_DROPDOWN = {
  en: {
    editReview: "Edit Review",
    addReview: "Add Review",
    removeReview: "Remove Review",
  },
  ar: {
    editReview: "تعديل التقييم",
    addReview: "إضافة تقييم",
    removeReview: "حذف التقييم",
  },
};

